import type { IHomepageMetricGroup } from '@skystone/shared';

export interface MetricGroupFormState {
  title: string;
  subtitle: string;
  sourceBadge: string;
  metricListPreview: string;
  linkTarget: string;
  isNew: boolean;
  visible: boolean;
  displayOrder: number;
}

export function toMetricGroupFormState(group: IHomepageMetricGroup): MetricGroupFormState {
  return {
    title: group.title,
    subtitle: group.subtitle,
    sourceBadge: group.sourceBadge,
    metricListPreview: group.metricListPreview,
    linkTarget: group.linkTarget,
    isNew: group.isNew,
    visible: group.visible,
    displayOrder: group.displayOrder,
  };
}

export const emptyMetricGroupFormState: MetricGroupFormState = {
  title: '',
  subtitle: '',
  sourceBadge: '',
  metricListPreview: '',
  linkTarget: '',
  isNew: false,
  visible: false,
  displayOrder: 100,
};

export function validateMetricGroupLinkTarget(value: string): string | null {
  if (value === '') return null;
  if (value.startsWith('/')) return null;
  try {
    const url = new URL(value);
    if (url.protocol === 'http:' || url.protocol === 'https:') return null;
  } catch {
    /* falls through */
  }
  return 'Must be empty, an internal path starting with "/", or an http(s) URL';
}

export function validateMetricGroupTitle(value: string): string | null {
  return value.trim().length === 0 ? 'Title is required' : null;
}
